import React from 'react';
import { Link } from 'react-router-dom';
import { GradientText } from '../components/ui/GradientText';
import { ArrowRight, Zap, Users, BarChart2, Globe2, Rocket, Shield, Coins, Settings, MessageSquare, Sparkles, Share2 } from 'lucide-react';
import Footer from '../components/Footer';

export default function Partners() {
  return (
    <div className="bg-black">
      {/* Hero Section */}
      <div className="relative pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(79,70,229,0.1),transparent_50%)]" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom_left,rgba(219,39,119,0.1),transparent_50%)]" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
              Become <GradientText>Partner</GradientText>
            </h1>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Join the Botmaker Agency ecosystem and grow your business with our innovative AI chatbot solutions.
            </p>
          </div>
        </div>
      </div>

      {/* Section Affiliation */}
      <section className="relative py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-white mb-4">
              Affiliation <GradientText>Program</GradientText>
            </h2>
            <p className="text-xl text-gray-400 max-w-3xl mx-auto">
              Recommend our solutions and earn attractive commissions on each sale made.
            </p>
          </div>

          {/* Avantages de l'affiliation */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
            <div className="bg-white/5 backdrop-blur-xl rounded-xl p-6 border border-white/10">
              <Coins className="w-12 h-12 text-indigo-400 mb-4" />
              <h3 className="text-xl font-semibold text-white mb-3">Generous Commissions</h3>
              <p className="text-gray-400">Up to 30% commission on every sale, with real-time tracking of your earnings.</p>
            </div>

            <div className="bg-white/5 backdrop-blur-xl rounded-xl p-6 border border-white/10">
              <BarChart2 className="w-12 h-12 text-purple-400 mb-4" />
              <h3 className="text-xl font-semibold text-white mb-3">Dedicated Dashboard</h3>
              <p className="text-gray-400">Track your performance, conversions and commissions through an intuitive interface.</p>
            </div>

            <div className="bg-white/5 backdrop-blur-xl rounded-xl p-6 border border-white/10">
              <Share2 className="w-12 h-12 text-pink-400 mb-4" />
              <h3 className="text-xl font-semibold text-white mb-3">Marketing Ressources</h3>
              <p className="text-gray-400">Access exclusive marketing tools to effectively promote our solutions.</p>
            </div>
          </div>

          {/* Call-to-Action Affiliation */}
          <div className="bg-gradient-to-br from-indigo-500/20 via-purple-500/20 to-pink-500/20 rounded-2xl p-1">
            <div className="bg-black rounded-xl p-8 text-center">
              <h3 className="text-2xl font-semibold text-white mb-4">
                Join our affiliate program
              </h3>
              <p className="text-gray-300 mb-6 max-w-2xl mx-auto">
                Start earning commissions today by recommending the best AI chatbot solution on the market.
              </p>
              <a 
                href="https://affiliation.botmaker-agency.com"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-indigo-600 via-purple-500 to-pink-500 text-white rounded-xl hover:shadow-[0_0_30px_rgba(79,70,229,0.3)] transition-all"
              >
                Become an Affiliate
                <ArrowRight className="w-4 h-4" />
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Section Marque Blanche */}
      <section className="relative py-20 bg-white/5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-white mb-4">
              Whitelabel <GradientText>Solution</GradientText>
            </h2>
            <p className="text-xl text-gray-400 max-w-3xl mx-auto">
              Offer our AI chatbot technology under your own brand and expand your service offering.
            </p>
          </div>

          {/* Fonctionnalités Marque Blanche */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
            <div className="bg-white/5 backdrop-blur-xl rounded-xl p-6 border border-white/10">
              <Settings className="w-12 h-12 text-indigo-400 mb-4" />
              <h3 className="text-xl font-semibold text-white mb-3">Complete Customization</h3>
              <p className="text-gray-400">Interface, logo, couleurs... Adaptez chaque aspect à votre identité de marque.</p>
            </div>

            <div className="bg-white/5 backdrop-blur-xl rounded-xl p-6 border border-white/10">
              <MessageSquare className="w-12 h-12 text-purple-400 mb-4" />
              <h3 className="text-xl font-semibold text-white mb-3">Solid API</h3>
              <p className="text-gray-400">Easily integrate our features into your existing applications.</p>
            </div>

            <div className="bg-white/5 backdrop-blur-xl rounded-xl p-6 border border-white/10">
              <Shield className="w-12 h-12 text-pink-400 mb-4" />
              <h3 className="text-xl font-semibold text-white mb-3">Enterprise Security</h3>
              <p className="text-gray-400">Secure infrastructure that complies with data protection standards.</p>
            </div>

            <div className="bg-white/5 backdrop-blur-xl rounded-xl p-6 border border-white/10">
              <Users className="w-12 h-12 text-green-400 mb-4" />
              <h3 className="text-xl font-semibold text-white mb-3">Multi-Clients</h3>
              <p className="text-gray-400">Easily manage multiple clients from a centralized interface.</p>
            </div>

            <div className="bg-white/5 backdrop-blur-xl rounded-xl p-6 border border-white/10">
              <Sparkles className="w-12 h-12 text-yellow-400 mb-4" />
              <h3 className="text-xl font-semibold text-white mb-3">Advanced AI</h3>
              <p className="text-gray-400">Access our most powerful AI models for your clients.</p>
            </div>

            <div className="bg-white/5 backdrop-blur-xl rounded-xl p-6 border border-white/10">
              <Rocket className="w-12 h-12 text-orange-400 mb-4" />
              <h3 className="text-xl font-semibold text-white mb-3">Dedicated support</h3>
              <p className="text-gray-400">Benefit from personalized support for your success.</p>
            </div>
          </div>

          {/* Call-to-Action Marque Blanche */}
          <div className="bg-gradient-to-br from-indigo-500/20 via-purple-500/20 to-pink-500/20 rounded-2xl p-1">
            <div className="bg-black rounded-xl p-8 md:p-12">
              <div className="max-w-3xl mx-auto text-center">
                <h3 className="text-2xl font-semibold text-white mb-4">
                  Grow your business with our white label solution
                </h3>
                <p className="text-gray-300 mb-8">
                 Take advantage of our proven technology to deliver powerful AI chatbots to your customers. Contact us to discuss your project and get a personalized demo.
                </p>
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                  <a 
                    href="https://calendly.com/martin-botmaker-agency/demo-botmaker-agency-ai"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-gradient-to-r from-indigo-600 via-purple-500 to-pink-500 text-white rounded-xl hover:shadow-[0_0_30px_rgba(79,70,229,0.3)] transition-all"
                  >
                    Book a demo
                    <ArrowRight className="w-4 h-4" />
                  </a>
                  <a 
                    href="https://botmaker-agency.com/white-label.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-white/5 text-white rounded-xl border border-white/10 hover:bg-white/10 transition-all"
                  >
                    Download the brochure
                    <ArrowRight className="w-4 h-4" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}